import React, { useMemo } from 'react';
import DynamicLayout from "./components/DynamicLayout";
import DynamicPrivateRoute from "./components/DynamicPrivateRoute";
import { ThemeProvider } from '@mui/material/styles';
import GlobalChatbotWidget from "./components/chat/GlobalChatbotWidget";
import CssBaseline from '@mui/material/CssBaseline';
import theme from './components/theme';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import MainLandingPage from './components/MainLandingPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import AccountDeletion from './components/AccountDeletion';
import Login from './components/Login';
import CreateUser from './components/CreateUser';
import ResetPassword from './components/ResetPassword';
import Home from './components/Home';
// ... import other components as needed ...
import ReportTimeOffRequest from './components/ReportTimeOffRequest';
import ReportTimeOffRequestManage from './components/ReportTimeOffRequestManage';
import StudentWalletAndIdCard from './components/StudentWalletAndIdCard';
import ReportStudentPersonalInformation from './components/ReportStudentPersonalInformation';
import ReportStudentPersonalInformationSearch from './components/ReportStudentPersonalInformationSearch';
import ReportStudentPersonalInformationUpdate from './components/ReportStudentPersonalInformationUpdate';
import UploadStudentPersonalInformation from './components/UploadStudentPersonalInformation';
import UpdateStudentID from './components/UpdateStudentID';
import ReportStudentMarks from './components/ReportStudentMarks';
import ReportStudentMarksSearch from './components/ReportStudentMarksSearch';
import PublicStudentApplication from './components/PublicStudentApplication';
import FormStudentApplication from './components/FormStudentApplication';
import ReportStudentApplication from './components/ReportStudentApplication';
import FormTimeOffRequest from './components/FormTimeOffRequest';
import FormAttendance from './components/FormAttendance';
import AttendanceReport from './components/AttendanceReport';
import ManageAttendanceReport from './components/ManageAttendanceReport';
import UpdateAttendanceReport from './components/UpdateAttendanceReport';
import ApproverTimeOffRequest from './components/ApproverTimeOffRequest';
import ApproverStudentApplication from './components/ApproverStudentApplication';
import ApproverVerifyStudentApplication from './components/ApproverVerifyStudentApplication';
import AnalyticsAttendance from './components/AnalyticsAttendance';
import ReportStudentBacklogs from './components/ReportStudentBacklogs';
import ReportStudentBacklogsSummary from './components/ReportStudentBacklogsSummary';
// import UpdateCodeSubCampus from './components/UpdateCodeSubCampus';
// import UpdateCodeDegree from './components/UpdateCodeDegree';
// import UpdateCodeCampusBranch from './components/UpdateCodeCampusBranch';
import UpdateDegreeSubjectMapping from './components/UpdateDegreeSubjectMapping';
import UpdateClasses from './components/UpdateClasses';
import UpdateClassSchedule from './components/UpdateClassSchedule';
import UpdateHostelRooms from './components/UpdateHostelRooms';
import FormHostelApplication from './components/FormHostelApplication';
import ApproverHostelApplication from './components/ApproverHostelApplication';
import ReportStudentHostel from './components/ReportStudentHostel';
// import UpdateTransportDetails from './components/UpdateTransportDetails';
// import UpdateTransportStops from './components/UpdateTransportStops';
// import UpdateTransportStopMapping from './components/UpdateTransportStopMapping';
import FormTransportApplication from './components/FormTransportApplication';
import ApproverTransportApplication from './components/ApproverTransportApplication';
import ReportStudentTransport from './components/ReportStudentTransport';
import ReportStudentFee from './components/ReportStudentFee';
import ReportStudentFeeAccounts from './components/ReportStudentFeeAccounts';
import ReportStudentFeeAdjustments from './components/ReportStudentFeeAdjustments';
import FormClassRegistration from './components/FormClassRegistration';
import ReportClassRegistration from './components/ReportClassRegistration';
import ReportClassSchedule from './components/ReportClassSchedule';
import UpdateCampusAnnouncements from './components/UpdateCampusAnnouncements';
import UpdateCampusEvents from './components/UpdateCampusEvents';
import UploadCodeSubjectDetails from './components/UploadCodeSubjectDetails';
import UploadTeachers from './components/UploadTeachers';
import UploadExternalMarks from './components/UploadExternalMarks';
// import UploadSemesters from './components/UploadSemesters';
import UploadSections from './components/UploadSections';
// import UploadCodeGrades from './components/UploadCodeGrades';
// import UploadStudentFeeStructure from './components/UploadStudentFeeStructure';
// import UploadStudentFeeStructureBundle from './components/UploadStudentFeeStructureBundle';
import UpdateStudentStatus from './components/UpdateStudentStatus';
import ManageStudentSemesterPromotion from './components/ManageStudentSemesterPromotion';
import ManageUsers from './components/ManageUsers';
import AILessonBuilderPage from './components/AILessonBuilderPage';
import AILessonStudentListPage from './components/AILessonStudentListPage';
import AILessonStudentPage from './components/AILessonStudentPage';
import AILessonTeacherHubPage from './components/AILessonTeacherHubPage';
//import AILessonTeacherListPage from './components/AILessonTeacherListPage';
import AILessonTeacherPage from './components/AILessonTeacherPage';
import AILessonAnalyticsPage from './components/AILessonAnalyticsPage';
import FormClassTopicManagement from './components/FormClassTopicManagement';
import FormStudentAssignment from './components/FormStudentAssignment';
import FormStudentAssignmentSubmission from './components/FormStudentAssignmentSubmission';
import FormStudentAssignmentGrading from './components/FormStudentAssignmentGrading';
import ApprovalQueueSetupPage from './components/ApprovalQueueSetupPage';
// import ManageRoleDean from './components/ManageRoleDean';
// import ManageRoleHOD from './components/ManageRoleHOD';
// import ManageRoleClassTeacher from './components/ManageRoleClassTeacher';
// import ManageRoleTeacher from './components/ManageRoleTeacher';
// import ManageRoleClassRepresentative from './components/ManageRoleClassRepresentative';
// import ManageRoleHostelManager from './components/ManageRoleHostelManager';
// import ManageRoleHostelViewer from './components/ManageRoleHostelViewer';
// import ManageHostelRepresentatives from './components/ManageHostelRepresentatives';
import HostelAttendance from './components/HostelAttendance';
import ManageHostelAttendanceReport from './components/ManageHostelAttendanceReport';
import UpdateHostelAttendanceReport from './components/UpdateHostelAttendanceReport';

import UploadEmployeeInformation from './components/UploadEmployeeInformation';
import StudentFeeReport from './components/StudentFeeReport';
import GuardScanner from './components/GuardScanner';
import GuardRegister from './components/GuardRegister';
import GuardPairing from './components/GuardPairing';
import FeedbackFormBuilder from './components/FeedbackFormBuilder';
import FeedbackFormFill from './components/FeedbackFormFill';
import FeedbackFormsList from './components/FeedbackFormsList';
import FeedbackFormAdmin from './components/FeedbackFormAdmin';
import FeedbackFormAnalytics from './components/FeedbackFormAnalytics';
import DashboardDean from './components/DashboardDean';
import StudentMarksAnalytics from './components/StudentMarksAnalytics';
import FormNAACSSR from './components/FormNAACSSR';
import AdminAuditAnalytics from './components/AdminAuditAnalytics';
import ReportBuilder from './components/ReportBuilder';
import StudentCareerProfile from './components/StudentCareerProfile';
import AdminStudentCareerProfileVerification from './components/AdminStudentCareerProfileVerification';
import AdminCareerTrack from './components/AdminCareerTrack';
import JobsInternships from './components/JobsInternships';
import JobsInternshipsAdmin from './components/JobsInternshipsAdmin';
import PaymentGatewaySetup from './components/PaymentGatewaySetup';
import AssetManagement from './components/AssetManagement';
import IdCardTemplateManager from './components/IdCardTemplateManager';
import IdCardGenerator from './components/IdCardGenerator';
import IssuedIdCards from './components/IssuedIdCards';
import IdCardPreview from './components/IdCardPreview';
import WalletAdminPage from './components/WalletAdminPage';
import WalletAdminDevicePage from './components/WalletAdminDevicePage';
import WalletBonusRulesPage from './components/WalletBonusRulesPage';
import WalletPosPage from './components/WalletPosPage';
import WalletGatePage from './components/WalletGatePage';
import UpdateAIProviderConfigs from './components/UpdateAIProviderConfigs';
import AIDeveloperPortal from './components/AIDeveloperPortal';
import AIDeveloperAdmin from './components/AIDeveloperAdmin';
// import UpdateNotificationProviderConfigs from './components/UpdateNotificationProviderConfigs';
// import UpdateNotificationChannelPreferencesPage from './components/UpdateNotificationChannelPreferencesPage';
import BackgroundTestPage from "./components/BackgroundTestPage";
import AcademicProjectHODManager from "./components/AcademicProjectHODManager";
import AcademicProjectClassTeacherManager from "./components/AcademicProjectClassTeacherManager";
import AcademicProjectStudentDashboard from './components/AcademicProjectStudentDashboard';
import WifiLoginPage from "./components/WifiLoginPage";
import UpdateCaptivePortalConfigPage from "./components/UpdateCaptivePortalConfigPage";
import ManageRolePageAccess from './components/ManageRolePageAccess';
import StudentDetailReport from './components/StudentDetailReport';
import StudentDetailReportSearch from './components/StudentDetailReportSearch';
import LiveClassroom from './components/liveclassroom/LiveClassroom';
import Whiteboard from './components/liveclassroom/Whiteboard';
import SetupAcademicCode from './components/SetupAcademicCode';
import SetupStudentFee from './components/SetupStudentFee';
import SetupNotification from './components/SetupNotification';
import SetupTransport from './components/SetupTransport';
import RoleAssignment from './components/RoleAssignment';
import AlumniRegister from './components/AlumniRegister';
import AlumniAdminPage_STUB from './components/AlumniAdminPage_STUB';
import AlumniAdminPage from './components/AlumniAdminPage';
import AlumniLogin, { AlumniAuthCallback } from './components/AlumniLogin';
import AlumniDashboard from './components/AlumniDashboard';
import StudentAlumniMentors from './components/StudentAlumniMentors';
import PromptStudio from './components/PromptStudio';
//SuperAdmin
import UpdateCodeCampus from './components/UpdateCodeCampus';
// ... any additional imports ...
import PrivateRoute from './components/PrivateRoute';

// import all existing pages same as now

const publicRoutes = [
  "/",
  "/login",
  "/Login",
  "/apply",
  "/guard",
  "/guard-register",
  "/bg-test",
  "/wifi-login",
  "/privacy",
  "/account-deletion",
  "/alumni/login",
  "/alumnilogin",
  "/alumni/auth/callback",
  "/alumni/dashboard",
];

const AppWrapper = () => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const isPublic = publicRoutes.includes(path) || /^\/alumni\/register\/[^/]+\/?$/.test(path);

  if (isPublic) {
    return (
      <Routes>
        <Route path="/" element={<MainLandingPage />} />
        {/* canonical lowercase login path */}
        <Route path="/login" element={<Login />} />
        {/* backward-compat redirect from /Login -> /login */}
        <Route path="/Login" element={<Login />} />
        <Route path="/apply" element={<PublicStudentApplication />} />
        <Route path="/guard" element={<GuardScanner />} />
        <Route path="/guard-register" element={<GuardRegister />} />
        <Route path="/bg-test" element={<BackgroundTestPage />} />
        <Route path="/wifi-login" element={<WifiLoginPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        <Route path="/alumni/login" element={<AlumniLogin />} />
        <Route path="/AlumniLogin" element={<AlumniLogin />} />
        <Route path="/alumni/auth/callback" element={<AlumniAuthCallback />} />
        {/* Dashboard verifies its own alumni token via /api/alumni/auth/me. */}
        <Route path="/alumni/dashboard" element={<AlumniDashboard />} />
        {/* Public alumni onboarding link from WhatsApp */}
        <Route path="/alumni/register/:token" element={<AlumniRegister />} />
      </Routes>
    );
  }  

  return (
    <DynamicLayout>
      <Routes>
        {/* Common private routes */}
        <Route path="/home" element={<DynamicPrivateRoute> <Home /></DynamicPrivateRoute> }/>
        {/* Personnel */}
        <Route path="/ReportStudentPersonalInformation" element={<DynamicPrivateRoute><ReportStudentPersonalInformation /></DynamicPrivateRoute>}/>
        <Route path="/StudentWalletAndIdCard" element={<DynamicPrivateRoute><StudentWalletAndIdCard /></DynamicPrivateRoute>} />       
        <Route path="/ReportStudentPersonalInformationSearch" element={<DynamicPrivateRoute><ReportStudentPersonalInformationSearch /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentPersonalInformationUpdate" element={<DynamicPrivateRoute><ReportStudentPersonalInformationUpdate /></DynamicPrivateRoute>} />
        {/* Academics */}
        <Route path="/FormClassRegistration" element={<DynamicPrivateRoute><FormClassRegistration /></DynamicPrivateRoute>} />
        <Route path="/PromptStudio" element={<DynamicPrivateRoute><PromptStudio /></DynamicPrivateRoute>} />
        <Route path="/LiveClassroom" element={<DynamicPrivateRoute><LiveClassroom /></DynamicPrivateRoute>} />
        <Route path="/Whiteboard" element={<DynamicPrivateRoute><Whiteboard /></DynamicPrivateRoute>} />
        <Route path="/ReportClassRegistration" element={<DynamicPrivateRoute><ReportClassRegistration /></DynamicPrivateRoute>} />
        <Route path="/ReportClassSchedule" element={<DynamicPrivateRoute><ReportClassSchedule /></DynamicPrivateRoute>} />
        <Route path="/AILessonBuilderPage" element={<DynamicPrivateRoute><AILessonBuilderPage /></DynamicPrivateRoute>} />
        <Route path="/student/lessons" element={<DynamicPrivateRoute><AILessonStudentListPage /></DynamicPrivateRoute>} />
        <Route path="/student/lessons/:lessonId" element={<DynamicPrivateRoute><AILessonStudentPage /></DynamicPrivateRoute>} />        
        <Route path="/AcademicProjectStudentDashboard" element={<DynamicPrivateRoute><AcademicProjectStudentDashboard /></DynamicPrivateRoute>} />
        {/* <Route path="/AILessonTeacherListPage" element={<DynamicPrivateRoute><AILessonTeacherListPage /></DynamicPrivateRoute>} /> */}
        <Route path="/AILessonTeacherHubPage" element={<DynamicPrivateRoute><AILessonTeacherHubPage /></DynamicPrivateRoute>} />
        <Route path="/AILessonTeacherPage/:lessonId" element={<DynamicPrivateRoute><AILessonTeacherPage /></DynamicPrivateRoute>} />
        <Route path="/AILessonAnalyticsPage/:lessonId" element={<DynamicPrivateRoute><AILessonAnalyticsPage /></DynamicPrivateRoute>} />
        <Route path="/AcademicProjectHODManager" element={<DynamicPrivateRoute><AcademicProjectHODManager /></DynamicPrivateRoute>} />
        <Route path="/AcademicProjectClassTeacherManager" element={<DynamicPrivateRoute><AcademicProjectClassTeacherManager /></DynamicPrivateRoute>} />
        <Route path="/FormClassTopicManagement" element={<DynamicPrivateRoute><FormClassTopicManagement /></DynamicPrivateRoute>} />
        <Route path="/FormStudentAssignment" element={<DynamicPrivateRoute><FormStudentAssignment /></DynamicPrivateRoute>} />
        <Route path="/FormStudentAssignmentSubmission" element={<DynamicPrivateRoute><FormStudentAssignmentSubmission /></DynamicPrivateRoute>} />
        <Route path="/FormStudentAssignmentGrading" element={<DynamicPrivateRoute><FormStudentAssignmentGrading /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentMarks" element={<DynamicPrivateRoute><ReportStudentMarks /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentMarksSearch" element={<DynamicPrivateRoute><ReportStudentMarksSearch /></DynamicPrivateRoute>} />
        <Route path="/StudentMarksAnalytics" element={<DynamicPrivateRoute><StudentMarksAnalytics /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentBacklogs" element={<DynamicPrivateRoute><ReportStudentBacklogs /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentBacklogsSummary" element={<DynamicPrivateRoute><ReportStudentBacklogsSummary /></DynamicPrivateRoute>} />
        {/* Career */}
        <Route path="/StudentCareerProfile" element={<DynamicPrivateRoute><StudentCareerProfile /></DynamicPrivateRoute>} />
        <Route path="/AdminStudentCareerProfileVerification" element={<DynamicPrivateRoute><AdminStudentCareerProfileVerification /></DynamicPrivateRoute>} />
        <Route path="/AdminCareerTrack" element={<DynamicPrivateRoute><AdminCareerTrack /></DynamicPrivateRoute>} />
        <Route path="/JobsInternships" element={<DynamicPrivateRoute><JobsInternships /></DynamicPrivateRoute>} />
        <Route path="/JobsInternshipsAdmin" element={<DynamicPrivateRoute><JobsInternshipsAdmin /></DynamicPrivateRoute>} />
        {/* Attendance */}
        <Route path="/FormAttendance" element={<DynamicPrivateRoute><FormAttendance /></DynamicPrivateRoute>} />
        <Route path="/AttendanceReport" element={<DynamicPrivateRoute><AttendanceReport /></DynamicPrivateRoute>} />
        <Route path="/ManageAttendanceReport" element={<DynamicPrivateRoute><ManageAttendanceReport /></DynamicPrivateRoute>} />
        <Route path="/UpdateAttendanceReport" element={<DynamicPrivateRoute><UpdateAttendanceReport /></DynamicPrivateRoute>} />
        <Route path="/AnalyticsAttendance" element={<DynamicPrivateRoute><AnalyticsAttendance /></DynamicPrivateRoute>} />
        <Route path="/FormTimeOffRequest" element={<DynamicPrivateRoute><FormTimeOffRequest /></DynamicPrivateRoute>} />
        <Route path="/ReportTimeOffRequest" element={<DynamicPrivateRoute><ReportTimeOffRequest /></DynamicPrivateRoute>} />
        <Route path="/ReportTimeOffRequestManage" element={<DynamicPrivateRoute><ReportTimeOffRequestManage /></DynamicPrivateRoute>} />
        <Route path="/ApproverTimeOffRequest" element={<DynamicPrivateRoute><ApproverTimeOffRequest /></DynamicPrivateRoute>} />
        {/* Admissions */}
        <Route path="/FormStudentApplication" element={<DynamicPrivateRoute><FormStudentApplication /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentApplication" element={<DynamicPrivateRoute><ReportStudentApplication /></DynamicPrivateRoute>} />
        <Route path="/ApproverStudentApplication" element={<DynamicPrivateRoute><ApproverStudentApplication /></DynamicPrivateRoute>} />
        <Route path="/ApproverVerifyStudentApplication" element={<DynamicPrivateRoute><ApproverVerifyStudentApplication /></DynamicPrivateRoute>} />
        {/* Hostel */}
        <Route path="/FormHostelApplication" element={<DynamicPrivateRoute><FormHostelApplication /></DynamicPrivateRoute>} />
        <Route path="/ApproverHostelApplication" element={<DynamicPrivateRoute><ApproverHostelApplication /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentHostel" element={<DynamicPrivateRoute><ReportStudentHostel /></DynamicPrivateRoute>} />
        <Route path="/HostelAttendance" element={<DynamicPrivateRoute><HostelAttendance /></DynamicPrivateRoute>} />
        <Route path="/ManageHostelAttendanceReport" element={<DynamicPrivateRoute><ManageHostelAttendanceReport /></DynamicPrivateRoute>} />
        <Route path="/UpdateHostelAttendanceReport" element={<DynamicPrivateRoute><UpdateHostelAttendanceReport /></DynamicPrivateRoute>} />
        {/* Transport */}
        <Route path="/FormTransportApplication" element={<DynamicPrivateRoute><FormTransportApplication /></DynamicPrivateRoute>} />
        <Route path="/ApproverTransportApplication" element={<DynamicPrivateRoute><ApproverTransportApplication /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentTransport" element={<DynamicPrivateRoute><ReportStudentTransport /></DynamicPrivateRoute>} />
        {/* Fee */}
        <Route path="/ReportStudentFee" element={<DynamicPrivateRoute><ReportStudentFee /></DynamicPrivateRoute>} />
        <Route path="/StudentFeeReport" element={<DynamicPrivateRoute><StudentFeeReport /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentFeeAccounts" element={<DynamicPrivateRoute><ReportStudentFeeAccounts /></DynamicPrivateRoute>} />
        <Route path="/ReportStudentFeeAdjustments" element={<DynamicPrivateRoute><ReportStudentFeeAdjustments /></DynamicPrivateRoute>} />     
        <Route path="/WalletAdminPage" element={<DynamicPrivateRoute><WalletAdminPage /></DynamicPrivateRoute>} />
        <Route path="/WalletAdminDevicePage" element={<DynamicPrivateRoute><WalletAdminDevicePage /></DynamicPrivateRoute>} />
        <Route path="/WalletBonusRulesPage" element={<DynamicPrivateRoute><WalletBonusRulesPage /></DynamicPrivateRoute>} />
        <Route path="/WalletPosPage" element={<DynamicPrivateRoute><WalletPosPage /></DynamicPrivateRoute>} />
        <Route path="/WalletGatePage" element={<DynamicPrivateRoute><WalletGatePage /></DynamicPrivateRoute>} />
        {/* Feedback */}
        {/* Feedback redirect routes */}
        <Route path="/feedback/forms" element={<DynamicPrivateRoute><FeedbackFormsList /></DynamicPrivateRoute>} />
        <Route path="/feedback/forms/:id" element={<DynamicPrivateRoute><FeedbackFormFill /></DynamicPrivateRoute>} />
        <Route path="/admin/feedback/builder" element={<DynamicPrivateRoute><FeedbackFormBuilder /></DynamicPrivateRoute>} />
        <Route path="/FeedbackFormAdmin" element={<DynamicPrivateRoute><FeedbackFormAdmin /></DynamicPrivateRoute>} />
        <Route path="/FeedbackFormAnalytics" element={<DynamicPrivateRoute><FeedbackFormAnalytics /></DynamicPrivateRoute>} />
        
        {/* Alumni */}
        <Route path="/StudentAlumniMentors" element={<DynamicPrivateRoute><StudentAlumniMentors /></DynamicPrivateRoute>} />
        <Route path="/AlumniRegister" element={<DynamicPrivateRoute><AlumniRegister /></DynamicPrivateRoute>} />
        <Route path="/AlumniAdminPage_STUB" element={<DynamicPrivateRoute><AlumniAdminPage_STUB /></DynamicPrivateRoute>} />
        <Route path="/AlumniAdminPage" element={<DynamicPrivateRoute><AlumniAdminPage /></DynamicPrivateRoute>} />

        {/* Dashboard */}
        <Route path="/DashboardDean" element={<DynamicPrivateRoute><DashboardDean /></DynamicPrivateRoute>} />
        <Route path="/StudentDetailReportSearch" element={<DynamicPrivateRoute><StudentDetailReportSearch /></DynamicPrivateRoute>} />
        <Route path="/StudentDetailReport" element={<DynamicPrivateRoute><StudentDetailReport /></DynamicPrivateRoute>} />

        {/* Admin */}
        <Route path="/FormNAACSSR" element={<DynamicPrivateRoute><FormNAACSSR /></DynamicPrivateRoute>} />
        <Route path="/PaymentGatewaySetup" element={<DynamicPrivateRoute><PaymentGatewaySetup /></DynamicPrivateRoute>} />
        <Route path="/AdminAuditAnalytics" element={<DynamicPrivateRoute><AdminAuditAnalytics /></DynamicPrivateRoute>} />
        <Route path="/ReportBuilder" element={<DynamicPrivateRoute><ReportBuilder /></DynamicPrivateRoute>} />
        <Route path="/SetupAcademicCode" element={<DynamicPrivateRoute><SetupAcademicCode /></DynamicPrivateRoute>} />
        <Route path="/SetupStudentFee" element={<DynamicPrivateRoute><SetupStudentFee /></DynamicPrivateRoute>} />
        {/*<Route path="/UpdateCodeSubCampus" element={<DynamicPrivateRoute><UpdateCodeSubCampus /></DynamicPrivateRoute>} /> */}
        <Route path="/AssetManagement" element={<DynamicPrivateRoute><AssetManagement /></DynamicPrivateRoute>} />        
        {/*<Route path="/UpdateCodeDegree" element={<DynamicPrivateRoute><UpdateCodeDegree /></DynamicPrivateRoute>} /> */}
        {/*<Route path="/UpdateCodeCampusBranch" element={<DynamicPrivateRoute><UpdateCodeCampusBranch /></DynamicPrivateRoute>} /> */}
        <Route path="/AIDeveloperPortal" element={<DynamicPrivateRoute><AIDeveloperPortal /></DynamicPrivateRoute>} />
        <Route path="/AIDeveloperAdmin" element={<DynamicPrivateRoute><AIDeveloperAdmin /></DynamicPrivateRoute>} />
        <Route path="/UpdateAIProviderConfigs" element={<DynamicPrivateRoute><UpdateAIProviderConfigs /></DynamicPrivateRoute>} />
        <Route path="/UpdateCaptivePortalConfigPage" element={<DynamicPrivateRoute><UpdateCaptivePortalConfigPage /></DynamicPrivateRoute>} />
        <Route path="/SetupNotification" element={<DynamicPrivateRoute><SetupNotification /></DynamicPrivateRoute>} />
        {/*<Route path="/UpdateNotificationProviderConfigs" element={<DynamicPrivateRoute><UpdateNotificationProviderConfigs /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/UpdateNotificationChannelPreferences" element={<DynamicPrivateRoute><UpdateNotificationChannelPreferencesPage /></DynamicPrivateRoute>} />*/}
        <Route path="/IdCardTemplateManager" element={<DynamicPrivateRoute><IdCardTemplateManager /></DynamicPrivateRoute>} />
        <Route path="/IdCardGenerator" element={<DynamicPrivateRoute><IdCardGenerator /></DynamicPrivateRoute>} />
        <Route path="/IssuedIdCards" element={<DynamicPrivateRoute><IssuedIdCards /></DynamicPrivateRoute>} />
        <Route path="/IdCardPreview" element={<DynamicPrivateRoute><IdCardPreview /></DynamicPrivateRoute>} />
        <Route path="/UpdateDegreeSubjectMapping" element={<DynamicPrivateRoute><UpdateDegreeSubjectMapping /></DynamicPrivateRoute>} />
        <Route path="/UploadCodeSubjectDetails" element={<DynamicPrivateRoute><UploadCodeSubjectDetails /></DynamicPrivateRoute>} />
        <Route path="/UpdateClasses" element={<DynamicPrivateRoute><UpdateClasses /></DynamicPrivateRoute>} />
        <Route path="/UpdateClassSchedule" element={<DynamicPrivateRoute><UpdateClassSchedule /></DynamicPrivateRoute>} />
        <Route path="/UpdateHostelRooms" element={<DynamicPrivateRoute><UpdateHostelRooms /></DynamicPrivateRoute>} />
        <Route path="/SetupTransport" element={<DynamicPrivateRoute><SetupTransport /></DynamicPrivateRoute>} />
        {/*<Route path="/UpdateTransportDetails" element={<DynamicPrivateRoute><UpdateTransportDetails /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/UpdateTransportStops" element={<DynamicPrivateRoute><UpdateTransportStops /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/UpdateTransportStopMapping" element={<DynamicPrivateRoute><UpdateTransportStopMapping /></DynamicPrivateRoute>} />*/}
        <Route path="/UpdateCampusAnnouncements" element={<DynamicPrivateRoute><UpdateCampusAnnouncements /></DynamicPrivateRoute>} />
        <Route path="/UpdateCampusEvents" element={<DynamicPrivateRoute><UpdateCampusEvents /></DynamicPrivateRoute>} />
        {/*<Route path="/UploadStudentFeeStructure" element={<DynamicPrivateRoute><UploadStudentFeeStructure /></DynamicPrivateRoute>} /> */}
        {/*<Route path="/UploadStudentFeeStructureBundle" element={<DynamicPrivateRoute><UploadStudentFeeStructureBundle /></DynamicPrivateRoute>} /> */}
        <Route path="/UpdateStudentStatus" element={<DynamicPrivateRoute><UpdateStudentStatus /></DynamicPrivateRoute>} />
        {/*<Route path="/UploadCodeGrades" element={<DynamicPrivateRoute><UploadCodeGrades /></DynamicPrivateRoute>} /> */}
        {/*<Route path="/UploadSemesters" element={<DynamicPrivateRoute><UploadSemesters /></DynamicPrivateRoute>} /> */}
        <Route path="/UploadSections" element={<DynamicPrivateRoute><UploadSections /></DynamicPrivateRoute>} />
        <Route path="/UploadTeachers" element={<DynamicPrivateRoute><UploadTeachers /></DynamicPrivateRoute>} />
        <Route path="/UploadEmployeeInformation" element={<DynamicPrivateRoute><UploadEmployeeInformation /></DynamicPrivateRoute>} />
        <Route path="/UploadStudentPersonalInformation" element={<DynamicPrivateRoute><UploadStudentPersonalInformation /></DynamicPrivateRoute>} />
        <Route path="/UpdateStudentID" element={<DynamicPrivateRoute><UpdateStudentID /></DynamicPrivateRoute>} />
        <Route path="/UploadExternalMarks" element={<DynamicPrivateRoute><UploadExternalMarks /></DynamicPrivateRoute>} />
        <Route path="/ManageStudentSemesterPromotion" element={<DynamicPrivateRoute><ManageStudentSemesterPromotion /></DynamicPrivateRoute>} />
        <Route path="/ManageRolePageAccess" element={<DynamicPrivateRoute><ManageRolePageAccess /></DynamicPrivateRoute>} />
        <Route path="/ManageUsers" element={<DynamicPrivateRoute><ManageUsers /></DynamicPrivateRoute>} />
        <Route path="/ApprovalQueueSetupPage" element={<DynamicPrivateRoute><ApprovalQueueSetupPage /></DynamicPrivateRoute>} />
        <Route path="/RoleAssignment" element={<DynamicPrivateRoute><RoleAssignment /></DynamicPrivateRoute>} />
        {/*<Route path="/ManageRoleDean" element={<DynamicPrivateRoute><ManageRoleDean /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageRoleHOD" element={<DynamicPrivateRoute><ManageRoleHOD /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageRoleClassTeacher" element={<DynamicPrivateRoute><ManageRoleClassTeacher /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageRoleTeacher" element={<DynamicPrivateRoute><ManageRoleTeacher /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageRoleClassRepresentative" element={<DynamicPrivateRoute><ManageRoleClassRepresentative /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageRoleHostelManager" element={<DynamicPrivateRoute><ManageRoleHostelManager /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageRoleHostelViewer" element={<DynamicPrivateRoute><ManageRoleHostelViewer /></DynamicPrivateRoute>} />*/}
        {/*<Route path="/ManageHostelRepresentatives" element={<DynamicPrivateRoute><ManageHostelRepresentatives /></DynamicPrivateRoute>} />*/}
        <Route path="/HostelAttendance" element={<DynamicPrivateRoute><HostelAttendance /></DynamicPrivateRoute>} />

        <Route path="/GuardPairing" element={<DynamicPrivateRoute><GuardPairing /></DynamicPrivateRoute>} />
        <Route path="/create-user" element={<DynamicPrivateRoute><CreateUser /></DynamicPrivateRoute>} />
        <Route path="/ResetPassword" element={<DynamicPrivateRoute><ResetPassword /></DynamicPrivateRoute>} />
        <Route path="*" element={<DynamicPrivateRoute><Home /></DynamicPrivateRoute>} />{/* Admin */}

        {/* add remaining private routes in same style */}

        {/* SuperAdmin */}
        <Route path="/UpdateCodeCampus" element={<DynamicPrivateRoute><UpdateCodeCampus /></DynamicPrivateRoute>} />{/* SuperAdmin */}
        <Route
          path="*"element={<DynamicPrivateRoute><Home /></DynamicPrivateRoute>}/></Routes>
      <GlobalChatbotWidget />
    </DynamicLayout>
  );
};

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Router>
      <AppWrapper />
    </Router>
  </ThemeProvider>
);

export default App;